import axios from 'axios'
import load from "@/LOAD.js";
import store from "@/store/index.js"
import storage from "./storage.js"

const instance = axios.create({

    baseURL: load.getUrlApi(),
});

// ----------------------------------
// ------------ REQUEST -------------
// ----------------------------------
instance.interceptors.request.use(config => {

    // Attesa
    /* store.commit('app/setLoading', true)*/

    // Imposto il token
    if (store.getters['auth/isAuthenticated'])
        config.headers.Authorization = storage.getAuthHeader()

    return config

}, function (error) {

    // Fine attesa
    /*   store.commit('app/setLoading', false) */

    // Request error
    console.log("request interceptor " + error)

    return Promise.reject(error)
})


// ----------------------------------
// ------------ RESPONSE ------------
// ----------------------------------
instance.interceptors.response.use(response => {

    // Fine attesa
    /*   store.commit('app/setLoading', false) */

    return response

}, function (error) {

    let originalRequest = error.config


    // Controllo scadenza token
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true
        return store.dispatch("auth/refreshToken").then(authResponse => {
            instance.defaults.headers.common['Authorization'] = 'Bearer ' + authResponse.data.access_token;
            originalRequest.headers['Authorization'] = 'Bearer ' + authResponse.data.access_token
            return instance(originalRequest)
        }).catch(err => {
            console.log(err)
            store.commit("auth/DEL_TOKEN")
        });
    }

    if (error.response) {
        const status = error.response.status
        const data = error.response.data

        // 400 = errore controllato dal backend con messaggio leggibile
        // 500 (o altro) = eccezione non gestita → messaggio generico
        const isUserMessage = status === 400
            && typeof data === 'string'
            && data.trim() !== ''

        const messaggio = isUserMessage
            ? data
            : 'Errore imprevisto. Riprova più tardi.'

        store.commit('app/showMessage', { testo: messaggio, tipo: 'error' })
    }

    return Promise.reject(error);

})

export default instance